export default __webpack_public_path__ + "static/media/Mobile-DD-Xpress.9cbdd9c7.png";